import { Skeleton } from 'antd';

import { Box } from '@frontend/legacy-components';

export const LoadingThumbnail = () => {
  return (
    <Box
      className="skeleton input class"
      as={Skeleton.Input}
      active={true}
      height="100%"
      width="100%"
      borderRadius="inherit"
      sx={{
        '&&>span': {
          height: '100%',
        },
      }}
    />
  );
};
